<template>
  <header class="header-nav">
    <!-- Promotional Banner -->
    <div class="promo-banner" v-if="showPromoBanner">
      <div class="promo-slider">
        <div class="promo-slide" :class="{ 'active': currentPromoIndex === 0, 'prev': currentPromoIndex === 4 }">
          <i class="fas fa-map-marker-alt"></i>
          <span>📍 Located in Kigali, Rwanda - Serving All of East Africa</span>
        </div>
        <div class="promo-slide" :class="{ 'active': currentPromoIndex === 1, 'prev': currentPromoIndex === 0 }">
          <i class="fas fa-phone"></i>
          <span>📞 Call Us: +250 788 539 359 | WhatsApp: +250 788 539 359</span>
        </div>
        <div class="promo-slide" :class="{ 'active': currentPromoIndex === 2, 'prev': currentPromoIndex === 1 }">
          <i class="fas fa-envelope"></i>
          <span>✉️ Email: info@rwandakigaliselfdrive.com | Book Online 24/7</span>
        </div>
        <div class="promo-slide" :class="{ 'active': currentPromoIndex === 3, 'prev': currentPromoIndex === 2 }">
          <i class="fas fa-star"></i>
          <span>⭐ #1 Car Rental in Rwanda - 500+ Happy Customers</span>
        </div>
        <div class="promo-slide" :class="{ 'active': currentPromoIndex === 4, 'prev': currentPromoIndex === 3 }">
          <i class="fas fa-shield-alt"></i>
          <span>🛡️ Full Insurance Included | No Hidden Fees</span>
        </div>
      </div>
      <button class="promo-close" @click="closePromoBanner" aria-label="Close banner">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="nav-container">
      <div class="logo">
        <router-link to="/" class="logo-link" @click="closeMenu">
          <img src="@/assets/images/logo.png" alt="Rwanda Kigali Selfdrive" class="logo-image" />
        </router-link>
      </div>

      <!-- Desktop Navigation -->
      <nav class="desktop-nav">
        <router-link to="/" class="nav-link">Home</router-link>
        <router-link to="/about" class="nav-link">About</router-link>
        <!-- Fleet Dropdown -->
        <div class="nav-dropdown" @mouseenter="showFleetDropdown = true" @mouseleave="showFleetDropdown = false">
          <a href="#" class="dropdown-toggle" @click.prevent>Our Vehicles <i class="fas fa-chevron-down"></i></a>
          <div class="dropdown-menu" :class="{ 'show': showFleetDropdown }">
            <router-link to="/fleet">All Vehicles</router-link>
            <router-link to="/fleet?category=economy">Economy Cars</router-link>
            <router-link to="/fleet?category=suv">SUV Vehicles</router-link>
            <router-link to="/fleet?category=4x4">4x4 & Safari</router-link>
            <router-link to="/fleet?category=luxury">Luxury Cars</router-link>
          </div>
        </div>

        <!-- Services Dropdown -->
        <div class="nav-dropdown" @mouseenter="showServicesDropdown = true" @mouseleave="showServicesDropdown = false">
          <a href="#" class="dropdown-toggle" @click.prevent>Services <i class="fas fa-chevron-down"></i></a>
          <div class="dropdown-menu" :class="{ 'show': showServicesDropdown }">
            <router-link to="/services">All Services</router-link>
            <router-link to="/services/self-drive">Self Drive</router-link>
            <router-link to="/services/driver-service">Car with Driver</router-link>
            <router-link to="/services/long-term">Long Term Rental</router-link>
            <router-link to="/services/airport-transfer">Airport Transfer</router-link>
            <router-link to="/services/safari-car">Safari Car Rental</router-link>
          </div>
        </div>

        <!-- Destinations Dropdown -->
        <div class="nav-dropdown" @mouseenter="showDestinationsDropdown = true" @mouseleave="showDestinationsDropdown = false">
          <a href="#" class="dropdown-toggle" @click.prevent>Destinations <i class="fas fa-chevron-down"></i></a>
          <div class="dropdown-menu" :class="{ 'show': showDestinationsDropdown }">
            <router-link to="/destinations">All Destinations</router-link>
            <router-link to="/destinations/volcanoes-national-park">Volcanoes National Park</router-link>
            <router-link to="/destinations/akagera-national-park">Akagera National Park</router-link>
            <router-link to="/destinations/nyungwe-forest">Nyungwe Forest</router-link>
            <router-link to="/destinations/lake-kivu">Lake Kivu</router-link>
            <router-link to="/destinations/kigali-city">Kigali City</router-link>
            <div class="dropdown-divider"></div>
            <router-link to="/destinations/visit-uganda" class="uganda-link">
              <i class="fas fa-plane"></i> Visit Uganda
            </router-link>
          </div>
        </div>

        <!-- Rwanda Dropdown -->
        <div class="nav-dropdown" @mouseenter="showRwandaDropdown = true" @mouseleave="showRwandaDropdown = false">
          <a href="#" class="dropdown-toggle" @click.prevent>Visit Rwanda <i class="fas fa-chevron-down"></i></a>
          <div class="dropdown-menu" :class="{ 'show': showRwandaDropdown }">
            <router-link to="/about-rwanda">About Rwanda</router-link>
            <router-link to="/about-rwanda/national-parks">National Parks</router-link>
            <router-link to="/about-rwanda/culture-heritage">Culture & Heritage</router-link>
            <router-link to="/about-rwanda/cities-towns">Cities & Towns</router-link>
            <router-link to="/about-rwanda/climate-best-time">Climate & Best Time</router-link>
            <router-link to="/about-rwanda/getting-around">Getting Around</router-link>
          </div>
        </div>

        <router-link to="/blog" class="nav-link">Blog</router-link>
        <router-link to="/customer-photos" class="nav-link">Gallery</router-link>
        <router-link to="/contact" class="nav-link">Contact</router-link>
        <router-link to="/book" class="cta-button">Book Now</router-link>
      </nav>

      <!-- Mobile Menu Button -->
      <button class="hamburger" :class="{ 'active': isMenuOpen }" @click="toggleMenu" aria-label="Toggle menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Mobile Navigation Overlay -->
    <div class="mobile-overlay" :class="{ 'active': isMenuOpen }" @click="closeMenu"></div>

    <!-- Mobile Navigation -->
    <div class="mobile-nav" :class="{ 'active': isMenuOpen }">
      <div class="mobile-nav-content">
        <router-link to="/" @click="closeMenu" class="mobile-link">
          <i class="fas fa-home"></i> Home
        </router-link>
        <router-link to="/about" @click="closeMenu" class="mobile-link">
          <i class="fas fa-info-circle"></i> About
        </router-link>
        <!-- Mobile Fleet Dropdown -->
        <div class="mobile-dropdown">
          <div class="mobile-dropdown-toggle" @click="toggleMobileDropdown('fleet')">
            <span><i class="fas fa-car"></i> Our Vehicles</span>
            <i class="fas fa-chevron-down" :class="{ 'rotated': mobileDropdowns.fleet }"></i>
          </div>
          <div class="mobile-dropdown-menu" :class="{ 'show': mobileDropdowns.fleet }">
            <router-link to="/fleet" @click="closeMenu">All Vehicles</router-link>
            <router-link to="/fleet?category=economy" @click="closeMenu">Economy Cars</router-link>
            <router-link to="/fleet?category=suv" @click="closeMenu">SUV Vehicles</router-link>
            <router-link to="/fleet?category=4x4" @click="closeMenu">4x4 & Safari</router-link>
            <router-link to="/fleet?category=luxury" @click="closeMenu">Luxury Cars</router-link>
          </div>
        </div>

        <!-- Mobile Services Dropdown -->
        <div class="mobile-dropdown">
          <div class="mobile-dropdown-toggle" @click="toggleMobileDropdown('services')">
            <span><i class="fas fa-concierge-bell"></i> Services</span>
            <i class="fas fa-chevron-down" :class="{ 'rotated': mobileDropdowns.services }"></i>
          </div>
          <div class="mobile-dropdown-menu" :class="{ 'show': mobileDropdowns.services }">
            <router-link to="/services" @click="closeMenu">All Services</router-link>
            <router-link to="/services/self-drive" @click="closeMenu">Self Drive</router-link>
            <router-link to="/services/driver-service" @click="closeMenu">Car with Driver</router-link>
            <router-link to="/services/long-term" @click="closeMenu">Long Term Rental</router-link>
            <router-link to="/services/airport-transfer" @click="closeMenu">Airport Transfer</router-link>
            <router-link to="/services/safari-car" @click="closeMenu">Safari Car Rental</router-link>
          </div>
        </div>

        <!-- Mobile Destinations Dropdown -->
        <div class="mobile-dropdown">
          <div class="mobile-dropdown-toggle" @click="toggleMobileDropdown('destinations')">
            <span><i class="fas fa-map-marked-alt"></i> Destinations</span>
            <i class="fas fa-chevron-down" :class="{ 'rotated': mobileDropdowns.destinations }"></i>
          </div>
          <div class="mobile-dropdown-menu" :class="{ 'show': mobileDropdowns.destinations }">
            <router-link to="/destinations" @click="closeMenu">All Destinations</router-link>
            <router-link to="/destinations/volcanoes-national-park" @click="closeMenu">Volcanoes National Park</router-link>
            <router-link to="/destinations/akagera-national-park" @click="closeMenu">Akagera National Park</router-link>
            <router-link to="/destinations/nyungwe-forest" @click="closeMenu">Nyungwe Forest</router-link>
            <router-link to="/destinations/lake-kivu" @click="closeMenu">Lake Kivu</router-link>
            <router-link to="/destinations/kigali-city" @click="closeMenu">Kigali City</router-link>
            <router-link to="/destinations/visit-uganda" @click="closeMenu" class="uganda-mobile-link">
              <i class="fas fa-plane"></i> Visit Uganda
            </router-link>
          </div>
        </div>

        <!-- Mobile Rwanda Dropdown -->
        <div class="mobile-dropdown">
          <div class="mobile-dropdown-toggle" @click="toggleMobileDropdown('rwanda')">
            <span><i class="fas fa-flag"></i> Visit Rwanda</span>
            <i class="fas fa-chevron-down" :class="{ 'rotated': mobileDropdowns.rwanda }"></i>
          </div>
          <div class="mobile-dropdown-menu" :class="{ 'show': mobileDropdowns.rwanda }">
            <router-link to="/about-rwanda" @click="closeMenu">About Rwanda</router-link>
            <router-link to="/about-rwanda/national-parks" @click="closeMenu">National Parks</router-link>
            <router-link to="/about-rwanda/culture-heritage" @click="closeMenu">Culture & Heritage</router-link>
            <router-link to="/about-rwanda/cities-towns" @click="closeMenu">Cities & Towns</router-link>
            <router-link to="/about-rwanda/climate-best-time" @click="closeMenu">Climate & Best Time</router-link>
            <router-link to="/about-rwanda/getting-around" @click="closeMenu">Getting Around</router-link>
          </div>
        </div>

        <router-link to="/blog" @click="closeMenu" class="mobile-link">
          <i class="fas fa-blog"></i> Blog
        </router-link>
        <router-link to="/customer-photos" @click="closeMenu" class="mobile-link">
          <i class="fas fa-images"></i> Gallery
        </router-link>
        <router-link to="/contact" @click="closeMenu" class="mobile-link">
          <i class="fas fa-envelope"></i> Contact
        </router-link>
        <router-link to="/book" @click="closeMenu" class="mobile-cta">
          <i class="fas fa-calendar-check"></i> Book Now
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderNav',
  data () {
    return {
      isMenuOpen: false,
      showPromoBanner: true,
      currentPromoIndex: 0,
      promoInterval: null,
      showFleetDropdown: false,
      showServicesDropdown: false,
      showDestinationsDropdown: false,
      showRwandaDropdown: false,
      mobileDropdowns: {
        fleet: false,
        services: false,
        destinations: false,
        rwanda: false
      }
    }
  },
  methods: {
    toggleMenu () {
      this.isMenuOpen = !this.isMenuOpen
      if (!this.isMenuOpen) {
        this.closeAllMobileDropdowns()
        document.body.style.overflow = 'auto'
      } else {
        document.body.style.overflow = 'hidden'
      }
    },
    closeMenu () {
      this.isMenuOpen = false
      this.closeAllMobileDropdowns()
      document.body.style.overflow = 'auto'
    },
    closeAllMobileDropdowns () {
      Object.keys(this.mobileDropdowns).forEach(key => {
        this.mobileDropdowns[key] = false
      })
    },
    toggleMobileDropdown (dropdown) {
      this.mobileDropdowns[dropdown] = !this.mobileDropdowns[dropdown]
    },
    closePromoBanner () {
      this.showPromoBanner = false
      if (this.promoInterval) {
        clearInterval(this.promoInterval)
      }
    },
    startPromoSlider () {
      this.promoInterval = setInterval(() => {
        this.currentPromoIndex = (this.currentPromoIndex + 1) % 5
      }, 5000)
    }
  },
  mounted () {
    this.startPromoSlider()
  },
  beforeUnmount () {
    if (this.promoInterval) {
      clearInterval(this.promoInterval)
    }
    document.body.style.overflow = 'auto'
  },
  watch: {
    $route () {
      this.closeMenu()
    }
  }
}
</script>

<style scoped>
/* Base Styles */
.header-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  border-bottom: 1px solid #e5e7eb;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

/* Promotional Banner */
.promo-banner {
  background: linear-gradient(135deg, #002F6C, #1E3A5F);
  color: white;
  padding: 0.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;
  height: 40px;
}

.promo-slider {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.promo-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  opacity: 0;
  transform: translateX(100%);
  transition: all 0.8s ease;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.promo-slide.active {
  opacity: 1;
  transform: translateX(0);
}

.promo-slide.prev {
  opacity: 0;
  transform: translateX(-100%);
}

.promo-slide i {
  color: #FF8C42;
}

.promo-close {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0.25rem;
  transition: all 0.3s ease;
  z-index: 10;
}

.promo-close:hover {
  color: #FF8C42;
  transform: scale(1.1);
}

/* Navigation Container */
.nav-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 90px;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-image {
  height: 70px;
  width: auto;
  max-width: 300px;
  object-fit: contain;
  transition: opacity 0.3s ease;
}

.logo-image:hover {
  opacity: 0.8;
}

/* Desktop Navigation */
.desktop-nav {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.nav-link {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  white-space: nowrap;
  padding: 0.5rem 0.75rem;
  border-radius: 5px;
}

.nav-link:hover {
  color: #002F6C;
  background: rgba(0, 47, 108, 0.05);
}

/* Dropdown Styles */
.nav-dropdown {
  position: relative;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  color: #333;
  text-decoration: none;
  padding: 0.5rem 0.75rem;
  border-radius: 5px;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 1rem;
  white-space: nowrap;
}

.dropdown-toggle:hover {
  color: #002F6C;
  background: rgba(0, 47, 108, 0.1);
}

.dropdown-toggle i {
  font-size: 0.8rem;
  transition: transform 0.3s ease;
}

.nav-dropdown:hover .dropdown-toggle i {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  min-width: 220px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 1rem 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
  border: 1px solid rgba(0, 47, 108, 0.1);
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-menu a {
  display: block;
  padding: 0.75rem 1.5rem;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 500;
}

.dropdown-menu a:hover {
  background: rgba(0, 47, 108, 0.1);
  color: #002F6C;
  transform: translateX(5px);
}

.dropdown-divider {
  height: 1px;
  background: #e9ecef;
  margin: 8px 0;
}

.uganda-link {
  background: rgba(255, 140, 66, 0.1);
  font-weight: 600;
  color: #002F6C;
}

.uganda-link i {
  margin-right: 8px;
  color: #FF8C42;
}

.uganda-link:hover {
  background: #FF8C42;
  color: white !important;
}

.uganda-link:hover i {
  color: white;
}

.cta-button {
  background: linear-gradient(135deg, #002F6C, #1E3A5F);
  color: white;
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 47, 108, 0.2);
}

.cta-button:hover {
  background: linear-gradient(135deg, #1E3A5F, #002F6C);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 47, 108, 0.3);
}

/* Hamburger Menu */
.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
  padding: 0.5rem;
  background: none;
  border: none;
}

.hamburger span {
  width: 28px;
  height: 3px;
  background: #002F6C;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(8px, -8px);
}

/* Mobile Overlay */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 998;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.mobile-overlay.active {
  opacity: 1;
  visibility: visible;
}

/* Mobile Navigation */
.mobile-nav {
  display: none;
  position: fixed;
  top: 130px;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  transform: translateX(-100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 999;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mobile-nav.active {
  transform: translateX(0);
}

.mobile-nav-content {
  padding: 1.5rem;
}

.mobile-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 0;
  color: #333;
  text-decoration: none;
  font-size: 1.05rem;
  border-bottom: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  font-weight: 500;
}

.mobile-link i {
  width: 20px;
  color: #002F6C;
}

.mobile-link:hover {
  color: #002F6C;
  padding-left: 1rem;
  background: rgba(0, 47, 108, 0.05);
}

.mobile-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  color: white;
  background: linear-gradient(135deg, #FF8C42, #E67E22);
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
  border-radius: 12px;
  margin-top: 1.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);
}

.mobile-cta:hover {
  background: linear-gradient(135deg, #E67E22, #D35400);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 140, 66, 0.4);
}

/* Mobile Dropdowns */
.mobile-dropdown {
  border-bottom: 1px solid #e5e7eb;
}

.mobile-dropdown-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  color: #333;
  font-size: 1.05rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-dropdown-toggle span {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.mobile-dropdown-toggle span i {
  width: 20px;
  color: #002F6C;
}

.mobile-dropdown-toggle:hover {
  color: #002F6C;
  background: rgba(0, 47, 108, 0.05);
  padding-left: 1rem;
}

.mobile-dropdown-toggle > i {
  transition: transform 0.3s ease;
  font-size: 0.9rem;
}

.mobile-dropdown-toggle > i.rotated {
  transform: rotate(180deg);
}

.mobile-dropdown-menu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease;
  background: rgba(0, 47, 108, 0.03);
}

.mobile-dropdown-menu.show {
  max-height: 500px;
  padding: 0.5rem 0;
}

.mobile-dropdown-menu a {
  display: block;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  color: #333;
  text-decoration: none;
  font-size: 0.95rem;
  border-bottom: 1px solid rgba(0, 47, 108, 0.05);
  transition: all 0.3s ease;
}

.mobile-dropdown-menu a:hover {
  color: #002F6C;
  background: rgba(0, 47, 108, 0.08);
  padding-left: 3rem;
}

.mobile-dropdown-menu a:last-child {
  border-bottom: none;
}

.uganda-mobile-link {
  background: rgba(255, 140, 66, 0.15) !important;
  font-weight: 600;
  margin-top: 0.5rem;
  border-radius: 8px;
  padding: 0.75rem 1rem 0.75rem 2.5rem !important;
}

.uganda-mobile-link i {
  margin-right: 8px;
  color: #FF8C42;
}

.uganda-mobile-link:hover {
  background: #FF8C42 !important;
  color: white !important;
  padding-left: 3rem !important;
}

.uganda-mobile-link:hover i {
  color: white;
}

/* Responsive Breakpoints */

/* Large Desktop */
@media (min-width: 1440px) {
  .nav-container {
    max-width: 1600px;
    padding: 0 3rem;
    height: 100px;
  }
  .logo-image {
    height: 80px;
    max-width: 350px;
  }
  .desktop-nav {
    gap: 2rem;
  }
}

/* Tablet & Below */
@media (max-width: 1024px) {
  .desktop-nav {
    display: none;
  }
  .hamburger {
    display: flex;
  }
  .mobile-nav {
    display: block;
  }
  .nav-container {
    height: 70px;
    padding: 0 1.5rem;
  }
  .logo-image {
    height: 55px;
    max-width: 220px;
  }
  .mobile-nav {
    top: 110px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .promo-banner {
    height: 32px;
    font-size: 0.75rem;
    padding: 0.4rem 1rem;
  }
  .nav-container {
    height: 60px;
    padding: 0 1rem;
  }
  .logo-image {
    height: 45px;
    max-width: 180px;
  }
  .mobile-nav {
    top: 92px;
  }
  .mobile-nav-content {
    padding: 1rem;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .promo-banner {
    height: 28px;
    font-size: 0.65rem;
    padding: 0.3rem 0.75rem;
  }
  .promo-slide span {
    font-size: 0.65rem;
  }
  .nav-container {
    height: 55px;
    padding: 0 0.75rem;
  }
  .logo-image {
    height: 40px;
    max-width: 150px;
  }
  .mobile-nav {
    top: 83px;
  }
  .mobile-nav-content {
    padding: 0.75rem;
  }
  .hamburger span {
    width: 24px;
    height: 2.5px;
  }
  .mobile-link,
  .mobile-dropdown-toggle {
    padding: 0.85rem 0;
    font-size: 0.95rem;
  }
  .mobile-dropdown-menu a {
    padding: 0.65rem 0.85rem 0.65rem 2rem;
    font-size: 0.9rem;
  }
  .mobile-cta {
    font-size: 1rem;
    padding: 0.9rem;
  }
}

/* Extra Small Mobile */
@media (max-width: 360px) {
  .promo-banner {
    height: 25px;
    font-size: 0.6rem;
    padding: 0.25rem 0.5rem;
  }
  .nav-container {
    height: 50px;
    padding: 0 0.5rem;
  }
  .logo-image {
    height: 36px;
    max-width: 130px;
  }
  .mobile-nav {
    top: 75px;
  }
  .mobile-nav-content {
    padding: 0.5rem;
  }
  .hamburger span {
    width: 22px;
    height: 2px;
  }
  .mobile-link,
  .mobile-dropdown-toggle {
    padding: 0.75rem 0;
    font-size: 0.9rem;
  }
  .mobile-link i,
  .mobile-dropdown-toggle span i {
    width: 18px;
    font-size: 0.9rem;
  }
  .mobile-dropdown-menu a {
    padding: 0.6rem 0.75rem 0.6rem 1.75rem;
    font-size: 0.85rem;
  }
  .mobile-cta {
    font-size: 0.95rem;
    padding: 0.85rem;
  }
}

/* Very Small Screens */
@media (max-width: 320px) {
  .logo-image {
    height: 32px;
    max-width: 110px;
  }
  .nav-container {
    height: 45px;
  }
  .mobile-nav {
    top: 70px;
  }
  .hamburger span {
    width: 20px;
  }
}
</style>
